module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Rome and Jules")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Tara Lain")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Two werewolf households, both alike in dignity….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Rome Siracusa, youngest son of the alpha of the nouveau-riche Siracusa pack, wants to be a faithful son and pack member, but he’s got two big secrets. One, he’s blessed with enhanced hearing, vision, strength, and the ability to shift at will. Second, he’s gay, a fact he can’t admit to his deadly homophobic father.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Rome crashes a party at the mansion of his pack’s greatest enemy, the ancient, pure-blooded Havillands. Jules, the gay son of the drunkard alpha, is being married off to a rich entrepreneur. Smitten and moved by the beautiful male’s plight, Rome tries to find a way to save Jules—while digging himself deeper into pack politics and navigating his own arranged marriage. Secrets climb out of the caves as the werewolf gods speak through the mouths of their children, and the two great families clash, suffocating the hopes of star-crossed lovers.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0